<script context="module">
  import Layout from '@/Layouts/Main.svelte';
  export const layout = Layout;
</script>

<script>
import { inertia } from '@inertiajs/inertia-svelte';
import { fade } from 'svelte/transition';
import { Inertia } from '@inertiajs/inertia';
import { onMount } from 'svelte';
import { slugify } from '@/utils';
import App from '@inertiajs/inertia-svelte/src/App.svelte';

export let postings = [];
export let exclude = [];
export let sector = null;
export let area = null;

// export let sourceOptions = [];
// export let languageOptions = [];
// export let sectorOptions = [];

// export let app_url;

let location_map = new Map();
let sector_map = new Map();
let area_map = new Map();

let locations = [];
let sectors = [];
let areas = [];

let filter = {
  location: '',
  sector: '',
  area: '',
};


onMount(() => {
  postings.forEach(posting => {
    let { location, sector, area } = posting;

    if (location)
      if (!location_map.has(location)) location_map.set(location, 1);

    if (sector)
      if (!sector_map.has(sector)) sector_map.set(sector, 1);

    if (area)
      if (!area_map.has(area)) area_map.set(area, 1);
  });

  locations = Array.from(location_map.keys()).sort();
  sectors = Array.from(sector_map.keys()).sort();
  areas = Array.from(area_map.keys()).sort();

  if (sector && sector_map.has(sector)) {
    filter.sector = sector;
  }
	if (area && area_map.has(area)) {
    filter.area = area;
  }
});


$: postingsFiltered = filterPostings(postings, filter);

function filterPostings(postings, filter) {
  return postings.filter(p => {
    if (exclude.includes(p.id)) return false;
    if (filter.location && p.location !== filter.location) return false;
    if (filter.sector && p.sector !== filter.sector) return false;
    if (filter.area && p.area !== filter.area) return false;
    return true;
  });
}

function resetFilter() {
  filter = {
    location: '',
    sector: '',
    area: '',
  };
}

function showDetail(posting, slug) {
  window.location.href = `/oferta/${slug}/${posting.id}`;
  /*
  Inertia.setPage({
    component: 'Detail',
    url: `/oferta/${slug}/${posting.id}`,
    props: {
      posting,
      sourceOptions,
      languageOptions,
      sectorOptions,
      back_url: 'list'
    },
    version: Inertia.page.version,
  }, {
    replace: false,
    preserveScroll: false,
    preserveState: true
  })
  */
}

</script>


<div class="bg-portada">
  <div class="marquee">
    <div class="marquee__inner text-6xl lg:text-7xl 2xl:text-8xl py-4" aria-hidden="true">
      <span>Ofertas de empleo.</span>
      <span>Ofertas de empleo.</span>
      <span>Ofertas de empleo.</span>
      <span>Ofertas de empleo.</span>
    </div>
  </div>
  <div class="opacity-portada"></div>
</div>
<!--
<div class="py-8 lg:py-16">
  <div class="container">
    <div class="lg:w-96">
        Consulta nuestras <strong>oportunidades profesionales</strong>.
    </div>
  </div>
</div>
-->
<div class="py-8 lg:py-16 bg-blue">
  <div class="container lg:flex items-center">
    <div class="lg:mr-5 mb-3 lg:mb-0 whitespace-nowrap text-white">
      Filtrar por
    </div>
    <div>
      <div class="lg:flex items-center">
        <div class="lg:mr-4 mb-3 lg:mb-0 relative">
          <select class="form-select
            appearance-none
            block
            w-full
            py-2
            pl-6
            pr-14
            bg-white
            border
            rounded-full
            transition
            ease-in-out
            m-0
            focus:border-blue focus:outline-none" aria-label="Área geográfica"
            bind:value={filter.location}>
              <option value="" selected>Localización</option>
              {#each locations as loc (loc)}
              <option value="{loc}">{loc}</option>
              {/each}

          </select>
          <div class="absolute inset-y-0 right-0 w-8 flex items-center">
            <i class="fa-solid fa-chevron-down"></i>
          </div>
        </div>
        {#if sectors.length}
        <div class="lg:mr-4 mb-3 lg:mb-0 relative">
          <select class="form-select
            appearance-none
            block
            w-full
            py-2
            pl-6
            pr-14
            bg-white
            border
            rounded-full
            transition
            ease-in-out
            m-0
            focus:border-blue focus:outline-none" aria-label="Sector"
            bind:value={filter.sector}>
              <option value="" selected>Sector</option>
              {#each sectors as sector (sector)}
              <option value="{sector}">{sector}</option>
              {/each}
          </select>
          <div class="absolute inset-y-0 right-0 w-8 flex items-center">
            <i class="fa-solid fa-chevron-down"></i>
          </div>
        </div>
        {/if}
        {#if areas.length}
        <div class="relative">
          <select class="form-select
            appearance-none
            block
            w-full
            py-2
            pl-6
            pr-14
            bg-white
            border
            rounded-full
            transition
            ease-in-out
            m-0
            focus:border-blue focus:outline-none" aria-label="Area"
            bind:value={filter.area}>
              <option value="" selected>Departamento</option>
              {#each areas as area (area)}
              <option value="{area}">{area}</option>
              {/each}
          </select>
          <div class="absolute inset-y-0 right-0 w-8 flex items-center">
            <i class="fa-solid fa-chevron-down"></i>
          </div>
        </div>
        {/if}
      </div>
    </div>
  </div>
</div>
<div class="py-8 lg:py-16">
  <div class="container">
    {#if postingsFiltered.length}
    <div class="my-2 text-center">
      {postingsFiltered.length} resultados
      {#each Object.keys(filter) as k}
      {#if filter[k]}
      <button class="rounded-full bg-transparent py-2 px-4 mx-2 border border-blue" on:click={() => {filter[k] = '';}}>
        {filter[k]} &times;
      </button>
      {/if}
      {/each}
    </div>

      <table class="min-w-full">
        <tbody>
          {#each postingsFiltered as p (p.id)}
          {@const slug = slugify(p.title)}
          <tr transition:fade class="bg-white border-b border-blue/20 transition duration-300 ease-in-out hover:bg-blue hover:text-white cursor-pointer" on:click|preventDefault={() => { showDetail(p, slug) }} >
            <td class="px-2 py-6 lg:px-6 lg:py-10">
              <div class="font-bold">
                {p.title}
              </div>
              <div>
                {p.location || '-'}
              </div>
            </td>
            <td class="px-2 py-6 lg:px-6 lg:py-10 whitespace-nowrap text-right">
              <a href="/oferta/{slug}/{p.id}" class="rounded-full bg-white text-blue font-semibold py-2 px-4 border border-blue">
                Ver oferta
              </a>
            </td>
          </tr>
          {/each}
        </tbody>
      </table>
    {:else}
      <p transition:fade class="text-xl mb-4">
        No hay ofertas de empleo que cumplan con los criterios de búsqueda.
      </p>
      <p>
        <button type="button" on:click={resetFilter} class="rounded-full bg-transparent hover:bg-blue text-blue font-semibold hover:text-white py-2 px-4 border border-blue hover:border-transparent">
        Restablecer filtros
        </button>
      </p>
    {/if}
  </div>
</div>


<div class="py-24 lg:py-32 bg-blue text-white rounded mx-4 lg:mx-24">
  <div class="container">

    <div class="text-center lg:max-w-3xl m-auto">

        <div class="text-4xl lg:text-5xl font-semibold">
          ¿Tenemos lo que buscas?
        </div>
        <div class="text-lg lg:text-xl mt-8 mb-16 font-semibold">
          Si no encuentras ninguna posición que se ajuste a tu perfil o expectativas profesionales, envíanos tu currículum para que podamos valorar tu candidatura en futuros procesos de selección.
        </div>
        <div>
          <a href="/oferta/envianos-tu-cv/" class="text-md rounded-full inline-block bg-white text-black font-bold py-4 px-12 border border-white">Envíanos tu CV</a>
        </div>

    </div>
  </div>
</div>
